import { HeaderService } from './header-service.ts';

export const HeaderServiceProxy = Symbol.for('HeaderServiceProxy');

export interface HeaderServiceProxy {
    headerService: HeaderService;
}
